<template>
    <div style="background: #FAFAFA;">
        <div>
            <!-- Modal -->
            <div class="modal fade" id="createAccount" tabindex="-1" aria-labelledby="createAccount" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title title-modal" id="createAccount">Add Account</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body mt-4 container" style="background: #FAFAFA;">
                            <div class="form-group">
                                <label for="bvn">BVN</label>
                                <input v-model="bvn" type="number" class="form-control inputt" id="bvn" placeholder="Enter BVN">
                            </div>
                            <div v-if=" this.validBvn" class="row">
                                <div class="col-md-6 col-6">
                                    <div class="form-group">
                                        <label for="fname">First Name</label>
                                        <input v-model="bvnForm.fname" disabled type="text" class="form-control inputt" id="bvn" placeholder="First name">
                                    </div>
                                </div>
                                
                                <div class="col-md-6 col-6">
                                    <div class="form-group">
                                        <label for="lname">Last Name</label>
                                        <input v-model="bvnForm.lname" disabled type="text" class="form-control inputt" id="lname" placeholder="Last name">
                                    </div>
                                </div>
                                <div class="col-md-6 col-6">
                                    <div class="form-group">
                                        <label for="oname">Other name</label>
                                        <input v-model="bvnForm.oname" disabled type="text" class="form-control inputt" id="oname" placeholder="Other name">
                                    </div>
                                </div>
                                <div class="col-md-6 col-6">
                                    <div class="form-group">
                                        <label for="email">Email</label>
                                        <input v-model="bvnForm.email" disabled type="email" class="form-control inputt" id="email" placeholder="Email">
                                    </div>
                                </div>
                                <div class="col-md-6 col-6">
                                    <div class="form-group">
                                        <label for="phone">Phone</label>
                                        <input v-model="bvnForm.phone" disabled type="number" class="form-control inputt" id="phone" placeholder="Phone">
                                    </div>
                                </div>
                                <div class="col-md-6 col-6">
                                    <div class="form-group">
                                        <label for="address">Address</label>
                                        <input v-model="bvnForm.address" disabled type="text" class="form-control inputt" id="addrerss" placeholder="Address">
                                    </div>
                                </div>
                               
                                <div class="col-md-6 col-6">
                                    <div class="form-group">
                                        <label for="gender">Gender</label>
                                        <input v-model="bvnForm.gender" disabled type="text" class="form-control inputt" id="gender" placeholder="gender">
                                    </div>
                                </div>
                                <div class="col-md-6 col-6">
                                    <div class="form-group">
                                        <label for="dob">Date of Birth</label>
                                        <input v-model="bvnForm.dob" disabled type="text" class="form-control inputt" id="dob" placeholder="Date of Birth">
                                    </div>
                                </div>
                            </div>
                        </div>            
                        <div class="form-group close-btn vote-btn container">
                            <button class="btn closee" data-dismiss="modal" aria-label="Close">Close</button>
                            <button :disabled="loading || bvn == ''" v-if="!validBvn" class="btn vote-now flex-fill mr-2" @click="verifyBVN()">
                                {{loading ? 'Verifying' : 'Verify'}}
                                <i
                                    class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                    v-if="loading"
                                ></i>
                            </button>
                            <button :disabled="loading" v-if="validBvn" class="btn vote-now flex-fill mr-2" @click="submitData()">
                                {{loading ? 'Processing' : 'Submit'}}
                                <i
                                    class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                    v-if="loading"
                                ></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
import $ from "jquery";
export default {
    name: "nhf-dashboard",
    components: {
        PageLoader,
    },
    props: {
        registrationType: String,
        // statusMessage: String
    },

    data() {
        return {
            loading: false,
            validBvn: false,
            bvn: "",
            bvnDataResponse: {},
            bvnForm: {
                fname: "",
                lname: "",
                oname: "",
                phone: "",
                dob: "",
                gender: "",
                address: "",
                email: "",
                nhf_number: "",
                // registrationType: "",
            },
            user: ""
        };
    },
    mounted() {
        this.user = JSON.parse(localStorage.getItem('shelta-user'));
        console.log("Check user", this.user.email)
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch((err) => {
            // console.log("none")
            });
        },
        verifyBVN() {
            this.loading = true;
            Api.postRequest(`bvncheckwithdojah`, { bvn: this.bvn }).then((res) => {
                this.loading = false;
                console.log("res", res)
                if(res.data.success) {
                    this.validBvn = true;
                    this.bvnDataResponse = res.data.data;
                    this.bvnForm.fname = res.data.data.first_name;
                    this.bvnForm.lname = res.data.data.last_name;
                    this.bvnForm.oname = res.data.data.middle_name;
                    this.bvnForm.email = this.user.email;
                    this.bvnForm.phone = res.data.data.phone_number1;
                    this.bvnForm.gender = res.data.data.gender;
                    this.bvnForm.address = res.data.data.address;
                    this.bvnForm.dob = res.data.data.date_of_birth;

                }
                if (res.data.error) {
                    this.$store.commit("setApiFailed", res.data.error);
                }
            }).catch((err) => {
             console.log(err)
             this.loading = false;
             this.validBvn = false;
            });
        },
        submitData() {
            this.loading = true;
            Api.postRequest(`setup-fmb`, {
                email: this.bvnForm.email,
                phone: this.bvnForm.phone,
                firstname: this.bvnForm.fname,
                lastname: this.bvnForm.lname,
                address: this.bvnForm.address,
                gender: this.bvnForm.gender,
                nhf_number: this.bvnForm.nhf_number,
            }).then(res => {
                console.log("New account carreted", res)
                this.loading = false;
                if (res.data.success) {
                    this.$emit('api-success', res.data); 
                    this.$store.commit("setApiSuccess", "Account Created Successfuly");
                    $("#createAccount")
                    .removeClass("fade")
                    .modal("hide");
                }
                if (res.data.error) {
                    this.$store.commit("setApiFailed", res.data.error);
                }
            }).catch((err) => {
             console.log(err)
             this.loading = false;
             this.validBvn = false;
            });
        }
        
    }
};
</script>

<style scoped lang="scss">
.title-modal {
    font-family: Nunito;
    font-weight: 800;
    font-size: 20px;
    line-height: 24px;
    color: #1C2B3A;
}

label {
    font-family: Lato;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #5D6F7C;
    display: flex;
}
.inputt {
    height: 48px;
    border-radius: 8px;
    padding: 12px;
    border: 1px solid #e8e9e9;
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: #1C2B3A;
    outline: 0;
    box-shadow: none;

}
.close-btn {
    margin-bottom: 2rem;
    .closee {
        border: 1px solid #2EBFCA;
        color: #2EBFCA;
        background: #ffffff;
        outline: 0;
        box-shadow: none;
        width: 100%;
    }
}

.vote-btn {
    margin-top: 40px;
    display: flex;
    .vote-now {
        background: #2AB3E6;
        color: #ffffff;
        border-radius: 8px;
        min-height: 38px;
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        width: 100%;
        outline: 0;
        box-shadow: none;
        margin-left: 10px;
    }
}
input:disabled {
  background-color: #ffffff;
//   color: #9a9a9a;
  opacity: 1;
}
</style>